import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { OAuthProvider } from '@sss/sdk';
import { sdk } from '../../lib/sdk';
import { startOAuthLogin } from '../../lib/oauth';
import AppleIcon from './AppleIcon';

const LABELS: Record<OAuthProvider, string> = { google: 'Google', apple: 'Apple', microsoft: 'Microsoft' };

/** "Continue with …" buttons for every provider the API has configured (none → renders nothing). */
export default function OAuthButtons({ returnUrl }: { returnUrl?: string }) {
  const { t } = useTranslation();
  const [providers, setProviders] = useState<OAuthProvider[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    sdk.config.get().then(
      (cfg) => {
        if (!cancelled) setProviders(cfg.auth.oauthProviders);
      },
      () => {},
    );
    return () => {
      cancelled = true;
    };
  }, []);

  if (providers.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', margin: '1rem 0' }}>
      <p style={{ textAlign: 'center', color: '#666', margin: 0 }}>{t('auth.or')}</p>
      {providers.map((provider) => (
        <button
          key={provider}
          type="button"
          onClick={() => startOAuthLogin(provider, returnUrl).catch((err: unknown) => setError(err instanceof Error ? err.message : 'Failed'))}
          style={button}
        >
          {provider === 'apple' && <AppleIcon />}
          {t('auth.continueWith', { provider: LABELS[provider] })}
        </button>
      ))}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

const button: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  padding: '0.5rem 1rem',
  cursor: 'pointer',
};
